import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=7f0c84c0&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"
import style0 from "./UserList.vue?vue&type=style&index=0&id=7f0c84c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0c84c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f0c84c0')) {
      api.createRecord('7f0c84c0', component.options)
    } else {
      api.reload('7f0c84c0', component.options)
    }
    module.hot.accept("./UserList.vue?vue&type=template&id=7f0c84c0&scoped=true", function () {
      api.rerender('7f0c84c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/components/UserList.vue"
export default component.exports